module.exports = __webpack_public_path__ + "images/flag-norway_0e36783896e7a36d481396dc28805303.svg";